<template>
    <div class="footer w-full bg-black">
        <div class="footer-message">
            <p v-html="trans.get('layouts.footer.info-1')">
            </p><br>
            <p v-html="trans.get('layouts.footer.info-2')"></p>
        </div>
        <div class="footer-container">
            <div class="elements-container flex flex-col lg:flex-row justify-between">
                <div class="logo xl:mr-24 lg:mr-12 flex justify-center lg:flex-col">
                    <a :href="routes['home']">
                        <img loading="lazy" class="hidden lg:block lg:w-48 xl:w-auto" src="/img/logo-vector-white-footer.svg" alt="Humboldt" />
                    </a>
                    <a :href="routes['home']">
                        <img loading="lazy" class="lg:hidden" src="/img/logo-vector-white-footer-mobile.svg" alt="Humboldt" />
                    </a>
                    <p class="text-center lg:text-lg text-base ml-6 lg:ml-0">Breeding stability with science & experience</p>
                </div>
                <div class="footer-links flex flex-col lg:flex-row lg:gap-12">
                    <div class="links-left flex flex-col justify-start items-start">
                        <!-- <a class="font-bold mb-6 lg:mb-5" :href="routes['faqs']">{{trans.get('layouts.footer.discover-our-seeds')}}</a> -->
                        <a class="font-bold mb-6 lg:mb-5 hover:text-light-grey" :href="routes['about']">{{trans.get('layouts.footer.about-us')}}</a>
                        <!-- <a class="font-bold mb-6 lg:mb-5" :href="routes.faqs">{{trans.get('layouts.footer.press')}}</a> -->
                        <a class="font-bold mb-6 lg:mb-5 hover:text-light-grey" :href="routes['contact']">{{trans.get('layouts.footer.contact')}}</a>
                    </div>
                    <div class="links-medium flex flex-col justify-start items-start">
                        <a class="font-bold mb-6 lg:mb-5 hover:text-light-grey" :href="routes['shipping-and-delivery']">{{trans.get('layouts.footer.shipping')}}</a>
                        <a class="font-bold mb-6 lg:mb-5 hover:text-light-grey" :href="routes['returns-policy']">{{trans.get('layouts.footer.returns')}}</a>
                        <a class="font-bold mb-6 lg:mb-5 hover:text-light-grey" :href="routes['faqs']">{{trans.get('layouts.footer.faq')}}</a>
                        <a class="font-bold mb-6 lg:mb-5 hover:text-light-grey" :href="routes['stores']">{{trans.get('layouts.footer.store-location')}}</a>
                        <div class="flex-col mb-5 flex lg:hidden">
                            <a target="__blank" href="https://www.instagram.com/hsceurope/" class="group flex text-beige hover:text-light-grey">
                                <img loading="lazy" src="/img/icons/instagram-white.svg" class="mr-4 mb-5 group-hover:filter-light-grey">Instagram
                            </a>
                            <a target="__blank" href="https://www.youtube.com/channel/UC_OEVIRPI6KQcb2h3gsq93Q" class="group flex text-beige hover:text-light-grey">
                                <img loading="lazy" src="/img/icons/youtube-white.svg" class="mr-4 group-hover:filter-light-grey">YouTube
                            </a>
                        </div>
                    </div>
                    <div class="links-right flex flex-col justify-start items-start">
                            <a class="text-beige mb-6 lg:mb-5 hover:text-light-grey" :href="routes['legal-disclaimer']">{{trans.get('layouts.footer.legal')}}</a>
                            <a class="text-beige mb-6 lg:mb-5 hover:text-light-grey" :href="routes['privacy-policy']">{{trans.get('layouts.footer.privacy-policy-cookies')}}</a>
                            <a class="text-beige mb-0 lg:mb-5 hover:text-light-grey" :href="routes['limitation-of-liability']">{{trans.get('layouts.footer.limit')}}</a>
                        <div class="flex-col mt-3 hidden lg:flex">
                            <a target="__blank" href="https://www.instagram.com/hsceurope/" class="group flex text-beige hover:text-light-grey">
                                <img loading="lazy" src="/img/icons/instagram-white.svg" class="mr-4 mb-5 group-hover:filter-light-grey">Instagram
                            </a>
                            <a target="__blank" href="https://www.youtube.com/channel/UC_OEVIRPI6KQcb2h3gsq93Q" class="group flex text-beige hover:text-light-grey">
                                <img loading="lazy" src="/img/icons/youtube-white.svg" class="mr-4 group-hover:filter-light-grey">YouTube
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Company from '../icons/Company.vue';
export default {
    components: { Company },
    props: {
        routes: {
            type: Object,
            required: true,
    },
  },
}
</script>

<style lang="scss">
.footer {
    .footer-message {
        background-color: #3a473b;
        padding: 3.125rem 1rem;
        p {
            max-width: 1200px;
            margin: auto;
            color: #c4cfc7;
            font-size: 16px;
            text-align: center;
        }
    }
    .footer-container {
        padding: 3.125rem 1.25rem;
        background-color: #000;
        @media (min-width: 1024px) {
            padding: 5.625rem 6.25rem;
            max-width: 1440px;
            margin: 0 auto;
        }
        .elements-container {
            color: white;
            .footer-links {
                @media (min-width: 1180px) {
                   gap: 7rem
                }
            }
            .logo{
                border-bottom: solid 0.5px #fff;
                margin-bottom:30px;

                @media (min-width: 1024px) {
                    width: 249px;
                    border-bottom: none;
                     max-width: 200px;
                }
                 @media (min-width: 1280px) {

                     max-width:none;
                }
                a {
                    margin-bottom: 32px;
                }
                p {
                    line-height: 1.56;
                }
            }
            a{
                text-decoration: none;
            }
        }
    }
}
</style>
